import { useState } from "react";
import { Menu, X } from "lucide-react";
import { ACCENT, ACCENT_LIGHT } from "../constants/theme";

export default function Navbar({ page, setPage }) {
  const [open, setOpen] = useState(false);

  const links = [
    "Home",
    "About",
    "Training Programs",
    "Join Us",
    "Contact",
    "Credits",
  ];

  const logo = "/nexus.png";

  const goToPage = (pageName) => {
    setPage(pageName);
    setOpen(false);
  };

  return (
    <nav
      aria-label="Main Navigation"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: "#fff",
        boxShadow: "0 1px 12px rgba(0,0,0,0.07)",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 68,
        }}
      >
        <button
          type="button"
          aria-label="Go to Home Page"
          onClick={() => goToPage("Home")}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logo}
              alt="Nexus Studio Logo"
              loading="eager"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>

          <span
            style={{
              fontWeight: 800,
              fontSize: 20,
              color: "#0f172a",
              letterSpacing: "-0.5px",
            }}
          >
            Nexus<span style={{ color: ACCENT }}>Studio</span>
          </span>
        </button>

        <div
          className="desktop-nav"
          style={{
            display: "flex",
            gap: 4,
            alignItems: "center",
          }}
        >
          {links.map((l) => (
            <button
              type="button"
              key={l}
              aria-current={page === l ? "page" : undefined}
              onClick={() => goToPage(l)}
              style={{
                border: "none",
                cursor: "pointer",
                padding: "8px 14px",
                borderRadius: 8,
                fontWeight: page === l ? 700 : 500,
                fontSize: 14.5,
                color: page === l ? ACCENT : "#374151",
                background: page === l ? ACCENT_LIGHT : "transparent",
                transition: "all 0.15s",
              }}
            >
              {l}
            </button>
          ))}

          <button
            type="button"
            aria-label="Join Us"
            onClick={() => goToPage("Join Us")}
            style={{
              marginLeft: 8,
              background: ACCENT,
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "9px 20px",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              transition: "opacity 0.15s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = 0.88)}
            onMouseOut={(e) => (e.currentTarget.style.opacity = 1)}
          >
            Join Us
          </button>
        </div>

        <button
          type="button"
          aria-label={open ? "Close Menu" : "Open Menu"}
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen(!open)}
          className="hamburger"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "none",
          }}
        >
          {open ? <X size={26} color="#0f172a" /> : <Menu size={26} color="#0f172a" />}
        </button>
      </div>

      {open && (
        <div
          id="mobile-menu"
          className="mobile-nav"
          style={{
            background: "#fff",
            borderTop: "1px solid #f1f5f9",
            padding: "12px 24px 20px",
          }}
        >
          {links.map((l) => (
            <button
              type="button"
              key={l}
              aria-current={page === l ? "page" : undefined}
              onClick={() => goToPage(l)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "12px 0",
                fontWeight: page === l ? 700 : 500,
                fontSize: 16,
                color: page === l ? ACCENT : "#374151",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              {l}
            </button>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }

          .hamburger {
            display: block !important;
          }
        }

        @media (min-width: 769px) {
          .mobile-nav {
            display: none !important;
          }
        }

        button:focus-visible {
          outline: 3px solid ${ACCENT};
          outline-offset: 2px;
        }
      `}</style>
    </nav>
  );
}